import { Radio, Select } from 'antd';
import {
  EMPLOYMENT_CATEGORY_OPTIONS,
  SPECIAL_EMPLOYMENT_OPTIONS,
  isNonEmploymentTypeValue,
} from '@/shared/employee';

// Controlled employment-type picker. The stored value is always a concrete type
// (unlimited/limited/ugovorODelu/...). The radio shows 3 categories: Unlimited /
// Limited / Special. Picking "Special" reveals a sub-select with the concrete
// non-employment types and stores that as the value. Receives value/onChange
// from the wrapping Form.Item.
export function EmploymentTypeControl({ value, onChange, disabled, t }) {
  const isSpecial = isNonEmploymentTypeValue(value);
  const category = isSpecial ? 'special' : value || 'unlimited';

  const handleCategory = (e) => {
    const next = e.target.value;
    if (next === 'special') {
      // Default to the first concrete special type unless already special.
      onChange(isSpecial ? value : SPECIAL_EMPLOYMENT_OPTIONS[0].value);
    } else {
      onChange(next);
    }
  };

  return (
    <div>
      <Radio.Group
        className="grid gap-4 sm:flex [&_label]:items-start [&_label]:justify-start"
        value={category}
        disabled={disabled}
        onChange={handleCategory}
      >
        {EMPLOYMENT_CATEGORY_OPTIONS.map(({ key, value: v }) => (
          <Radio
            key={key}
            value={v}
            className="mr-0 w-full rounded border border-zinc-200 bg-white px-2 py-1 hover:border-accent"
          >
            {t(key, { ns: 'forms' })}
          </Radio>
        ))}
      </Radio.Group>

      {isSpecial && (
        <div className="mt-3 max-w-sm">
          <label className="mb-1 block text-xs text-gray-500">
            {t('specialEmploymentType', { ns: 'forms' })}
          </label>
          <Select
            className="w-full"
            value={value}
            disabled={disabled}
            onChange={(v) => onChange(v)}
            options={SPECIAL_EMPLOYMENT_OPTIONS.map(({ key, value: v }) => ({
              value: v,
              label: t(key, { ns: 'forms' }),
            }))}
          />
        </div>
      )}
    </div>
  );
}
